import React, { ReactNode } from 'react'
import styles from '../../styles/admin/SignIn.module.scss'

type LayoutType = 'none' | 'standard' | 'secondary' | 'tertiary'

interface ContentBoxProps {
  children: ReactNode
  layout?: LayoutType
  width?: string
  mobileWidth?: string
  height?: string
  mobileHeight?: string
  padding?: string
  mobilePadding?: string
}

const ContentBox: React.FC<ContentBoxProps> = ({
  children,
  layout = 'standard',
  width,
  mobileWidth,
  height,
  mobileHeight,
  padding,
  mobilePadding,
}) => {
  const renderMonsters = () => {
    switch (layout) {
      case 'none':
        return null

      case 'standard':
        return (
          <>
            <img
              src="/assets/eye-red-monster.png"
              alt="Monster"
              className={styles.topLeftMonster}
            />
            <img
              src="/assets/smart-green-monster.png"
              alt="Monster"
              className={styles.topRightMonster}
            />
            <img
              src="/assets/rabbit-blue-monster.png"
              alt="Monster"
              className={styles.bottomRightMonster}
            />
          </>
        )

      case 'secondary':
        return (
          <>
            <img
              src="/assets/confetti-monsters.png"
              alt="Monster"
              className={styles.secondaryMonster}
            />
          </>
        )

      case 'tertiary':
        return (
          <>
            <img
              src="/assets/red-green-blue-monsters.png"
              alt="Monster"
              className={styles.tertiaryMonster}
            />
          </>
        )

      default:
        return null
    }
  }

  return (
    <div
      className={styles.signInContentContainer}
      style={
        {
          '--custom-width': width,
          '--custom-height': height,
          '--mobile-width': mobileWidth,
          '--mobile-height': mobileHeight,
          '--custom-padding': padding,
          '--mobile-padding': mobilePadding,
        } as React.CSSProperties
      }
    >
      {renderMonsters()}
      {children}
    </div>
  )
}

export default ContentBox
